import HttpClient from "./axios-helper/HttpClient";

export const getContractDetails = async (contractData) => {
    let headers = {
        'Content-Type': "application/json;",
    }

    try {
        const res = await HttpClient.get(`GetContractDetails`, headers, contractData);
        //res.data = claimDetails;
        return res;
    } catch (e) {
        return e;
    }
};

export const createClaim = async (claimData) => {
    let headers = {
        'Content-Type': "application/json;",
        'Authorization': localStorage.getItem('gcp-token')
    }
    try {
        const res = await HttpClient.post(`CreateClaim`, claimData, headers);
        return res;
    } catch (e) {
        if (e.response != null && e.response.status === 401) {
            window.location = window.location.origin + '/' + window.location.pathname.split("/")[1];
        }
        return e;
    }
}

export const getClaimDetails = async (claimId) => {
    let headers = {
        'Content-Type': "application/json;",
        'Authorization': localStorage.getItem('gcp-token')
    }
    
    try {
        const res = await HttpClient.get(`GetClaimDetails/` + claimId, headers);
        return res;
    } catch (e) {
        if (e.response != null && e.response.status === 401) {
            window.location = window.location.origin + '/' + window.location.pathname.split("/")[1];
        }
        return e;
    }
}

export const getExistingClaimDetails = async (claimQuery) => {
    let headers = {
        'Content-Type': "application/json;"
    }
    try {
        const res = await HttpClient.get(`GetClaimDetails`, headers, claimQuery);
        return res;
    } catch (e) {
        return e;
    }
}

export const getLossTypes = async () => {
    let headers = {
        'Content-Type': "application/json;",
        'Authorization': localStorage.getItem('gcp-token')
    }
    try {
        const res = await HttpClient.get(`GetLossTypes`, headers);
        return res;
    } catch (e) {
        if (e.response != null && e.response.status === 401) {
            window.location = window.location.origin + '/' + window.location.pathname.split("/")[1];
        }
        return e;
    }
}

// Returns the authenticated principal's tenant-relevant claims (lastName,
// isLender, tpa) when an OIDC cookie or form-issued JWT is present, or
// null when the caller is anonymous. Note: tpa is populated only on the
// OIDC cookie principal; the form-issued JWT path carries no tpa — so
// (authenticated && tpa) is what uniquely identifies an IdP session.
// Null is a documented state — the caller renders the legacy anonymous UX
// (no field lock, no prefill).
export const getCurrentUser = async () => {
    let headers = {
        'Content-Type': "application/json;"
    }
    try {
        const res = await HttpClient.get(`api/me`, headers);
        return res?.data ?? null;
    } catch (e) {
        if (e?.response?.status === 401) {
            return null;
        }
        return null;
    }
}

export const getInstructionalDoc = async (tpaId) => {
    let headers = {
        'Content-Type': "application/json;"
    }
    try {
        const res = await HttpClient.getAttachment(`GetInstructionalDoc/${tpaId}`, headers);
        return res;
    } catch (e) {
        if (e.response != null && e.response.status === 401) {
            window.location = window.location.origin + '/' + window.location.pathname.split("/")[1];
        }
        return e;
    }
}